import { Button, ButtonType } from "@/components/common/button";
import { getDisclaimersData } from "@/pages/quiz/base/questions/disclaimerAcknowledgment/common";
import CustomCheckbox from "@/pages/quiz/base/questions/disclaimerAcknowledgment/components/CustomCheckbox";
import Description from "@/pages/quiz/base/questions/disclaimerAcknowledgment/components/Description";

import { DisclaimerItem } from "@/pages/quiz/base/questions/disclaimerAcknowledgmentOneSubmit/components/DisclaimerItem";
import { useGetIsYounger64 } from "@/pages/quiz/base/hooks/useGetIs64OrOver";
import {useGetGender} from "@/pages/quiz/base/hooks/useGetGender";

type FormFieldName = "agree";
type ContactFieldsValues = Record<FormFieldName, boolean>;

type QuizQuestionProps<T> = {
  questionValue: T;
  setQuestionValue: (value: T) => void;
  setQuestionAnswer: (value: T) => void;
};

const DisclaimerAcknowledgmentOneSubmit = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const isYounger64 = useGetIsYounger64();
    const { isMale } = useGetGender();

  const onChange = () => {
    const newValues = { agree: !questionValue?.agree };
    setQuestionValue(newValues);
  };

  const isDisableButton = !questionValue.agree;

  return (
    <div className="flex flex-col justify-center">
      <p className="section-title">
        Please review and agree to the following precautions
      </p>
      <div className="space-y-4">
        <Description
          description={
            "Read the following for more information about this product and its potential side effects."
          }
        />

        {getDisclaimersData(isYounger64, isMale).map((disclaimerData, idx) => (
          <DisclaimerItem key={idx} disclaimerData={disclaimerData} />
        ))}
      </div>

      <Button
        type={ButtonType.CONTINUE}
        disabled={isDisableButton}
        onClick={() => setQuestionAnswer(questionValue)}
      />

      <div className="mt-2">
        <CustomCheckbox
          onChange={onChange}
          isChecked={questionValue?.agree || false}
          name="agree"
          label={
            <div className="text-sm font-normal -ml-4">
              I have answered questions of this survey truthfully to help tailor
              my treatment appropriately. By clicking “
              <span className="font-bold">Continue</span>”, I agree to the{" "}
              <span className="font-bold">Telehealth consent</span> and{" "}
              <span className="font-bold">
                acknowledge the potential side effects
              </span>{" "}
              and {!isMale && <><span className="font-bold">pregnancy precaution</span> and{" "}</>}
              <span className="font-bold">
                medication adjustment acknowledgement and consent
              </span>{" "}
              {!isYounger64 && (
                <>
                  and{" "}
                  <span className="font-bold">
                    the Medicare & Medicaid non-participation notice
                  </span>{" "}
                </>
              )}
              stated above.
            </div>
          }
        />
      </div>
    </div>
  );
};

export { DisclaimerAcknowledgmentOneSubmit };
